import React from "react";

export default function SQLServer_CHARINDEX() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQLServer_CHARINDEX</h1>
      <p>This is the SQLServer_CHARINDEX component generated from the SQL JSON.</p>
    </div>
  );
}
